import OrdenDeDespacho from './OrdenDeDespacho'

export default OrdenDeDespacho
